<script>
  import { checkbox } from 'vue-strap';
  import estados from '~js/estados';
  import projetoServico from '~modulos/projeto/servico';
  import pessoaServico from '~modulos/acessos/servico';
  
  export default {
    components: { checkbox },
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
      edicao: {
        type: Boolean,
        required: false, 
        default: false, 
      },
      desabilitarBeneficiario: {
        type: Boolean,
        default: false,
      },
      carregando: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        estados: estados,
        projetos: [],
        configuracao: this.$storage.configuracao(),
        desabilitarEndereco: false,
      }
    },
    methods: {
      permitirCriarSolicitacao(data) {
        return !(data && moment(data).add(1, "d").diff(moment()) < 0);
      },
      validar() {
        return this.$validator.validateAll();
      },
      listaDeProjetos() {
        return projetoServico
          .lista("SolFaturamento")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      setarProjeto(idProjeto) {
        this.projetos.map(projeto => {
          if (projeto.idProjeto == idProjeto) {
            this.$set(this.solicitacao, 'projeto', projeto);
          }
        });
      },
      iniciarSelect2Projeto() {
        const _this = this;

        $('#projeto').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR"
        })
          .change(function(e) {
            _this.$set(_this.solicitacao, 'idProjeto', this.value);

            _this.setarProjeto(this.value);

            if (!this.value) return;
          });
      },
      getCEP() {
        if (this.carregando) return;

        let textoCEP = this.solicitacao.cepFaturamento.replace('-', '').replace('.', '')

        if (textoCEP.length == 8) {
          this.desabilitarEndereco = true;

          pessoaServico
            .cep(textoCEP)
            .then(cepObj => {
              this.solicitacao.enderecoFaturamento = cepObj.logradouro.substring(0, 60);
              this.solicitacao.bairroFaturamento = cepObj.bairro.substring(0, 60);
              this.solicitacao.cidadeFaturamento = cepObj.localidade.substring(0, 60);
              this.solicitacao.ufFaturamento = cepObj.uf;
              this.solicitacao.numeroFaturamento = "";
              this.solicitacao.complementoFaturamento = "";
              this.desabilitarEndereco = false;
            })
            .catch(error => {
              this.desabilitarEndereco = false;
            });
        }
      }
    },
    computed: {
      validarConta() {
        return this.configuracao.selecaoDeContaWeb ? 'required' : '';
      },
    },
    mounted() {
      $('label.checkbox')
        .css('margin-top', 0)
        .css('margin-bottom', 5)
        .addClass('control-label');

      this.listaDeProjetos();
      this.iniciarSelect2Projeto();
    },
    updated(){
        const _this = this;

        this.$watch('solicitacao.cepFaturamento', function () {
        _this.getCEP();
        })
    },
    watch: {

    }
  }
</script>

<template>
  <div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('projeto')}" v-if="!edicao">
          <label class="control-label" for="projeto">Projeto</label>

          <select
            id="projeto"
            class="form-control"
            v-model="solicitacao.idProjeto"
            data-vv-name="projeto"
            v-validate="'required'">
            <option :value="projeto.idProjeto"
                    v-for="(projeto, index) in projetos"
                    :disabled="!permitirCriarSolicitacao(projeto.dataLimiteSolFaturamento) || projeto.acompanhamentoPendente">
              {{ projeto.nomeProjeto }}

              <template v-if="!permitirCriarSolicitacao(projeto.dataLimiteSolFaturamento)">
                (Data limite até: {{ projeto.dataLimiteSolFaturamento | formatarData }})
              </template>

              <template v-if="projeto.acompanhamentoPendente && permitirCriarSolicitacao(projeto.dataLimiteSolFaturamento)">
                (Projeto bloqueado para solicitações, favor responder o acompanhamento deste projeto que está em atraso)
              </template>
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
        </div>

        <div class="form-group required" v-if="edicao">
          <label class="control-label" for="projeto">Projeto</label>

          <input
            type="text"
            class="form-control"
            v-model="solicitacao.projeto.nomeProjeto"
            disabled>
        </div>
      </div>
    </div>

    <hr class="margin-top-10">
    
    <div class="row">
      <div class="col-sm-8">
        <div class="form-group required" :class="{'has-error': errors.has('nome')}">
          <label class="control-label" for="nome">Nome</label>

          <input 
              type="text"
              class="form-control"
              id="nome"
              v-model="solicitacao.nome"
              data-vv-name="nomeTerceiro"
              data-vv-as="Nome do beneficiário"
              v-validate="'required'"
              maxlength="100"
              :disabled="desabilitarBeneficiario">

          <p class="text-danger" v-show="errors.has('nome')">{{ errors.first('nome') }}</p>
        </div>
      </div>
      
      <div class="col-sm-4">
        <div class="form-group required">
          <label class="control-label" for="documento">{{ solicitacao.documento.length === 14 ? 'CPF' : 'CNPJ'}}</label>

          <input 
              type="text"
              class="form-control"
              id="documento"
              v-model="solicitacao.documento"
              disabled>
        </div>
      </div>
    </div>
    
    <div class="row" v-show="solicitacao.documento.length > 14">
      <div class="col-sm-6">
        <div class="form-group">
          <label class="control-label" for="inscricao-estadual">Ins. estadual</label>

          <input
            id="inscricao-estadual"
            class="form-control"
            type="text"
            v-model="solicitacao.inscricaoEstadual"
            maxlength="20">
        </div>
      </div>
      
      <div class="col-sm-6">
        <div class="form-group">
          <label class="control-label" for="inscricao-municipal">Ins. municipal</label>

          <input
            id="inscricao-municipal"
            class="form-control"
            type="text"
            v-model="solicitacao.inscricaoMunicipal"
            maxlength="20">
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('cepFaturamento')}">
          <label class="control-label" for="cep-faturamento">CEP</label>

          <input type="text"
                 class="form-control"
                 id="cep-faturamento"
                 v-model="solicitacao.cepFaturamento"
                 data-vv-as="cep"
                 :disabled="desabilitarEndereco"
                 data-vv-name="cepFaturamento"
                 v-validate="'required'"
                 v-mascara="'cep'">

          <p class="text-danger" v-show="errors.has('cepFaturamento')">{{ errors.first('cepFaturamento') }}</p>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group required" :class="{'has-error': errors.has('enderecoFaturamento')}">
          <label class="control-label" for="endereco-faturamento">Endereço</label>

          <input id="endereco-faturamento"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.enderecoFaturamento"
                 data-vv-name="enderecoFaturamento"
                 :disabled="desabilitarEndereco"
                 data-vv-as="endereço"
                 v-validate="'required'"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('enderecoFaturamento')">{{ errors.first('enderecoFaturamento') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('numeroFaturamento')}">
          <label class="control-label" for="numero-faturamento">Número</label>

          <input id="numero-faturamento"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.numeroFaturamento"
                 data-vv-name="numeroFaturamento"
                 data-vv-as="número"
                 v-validate="'required'"
                 maxlength="10">

          <p class="text-danger" v-show="errors.has('numeroFaturamento')">{{ errors.first('numeroFaturamento') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label" for="complemento-faturamento">Complemento</label>

          <input id="complemento-faturamento"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.complementoFaturamento"
                 maxlength="30">
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('bairroFaturamento')}">
          <label class="control-label" for="bairro-faturamento">Bairro</label>

          <input type="text"
                 class="form-control"
                 id="bairro-faturamento"
                 v-model="solicitacao.bairroFaturamento"
                 data-vv-as="bairro"
                 data-vv-name="bairroFaturamento"
                 :disabled="desabilitarEndereco"
                 v-validate="'required'"
                 maxlength="60">

          <p class="text-danger" v-show="errors.has('bairroFaturamento')">{{ errors.first('bairroFaturamento') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('cidadeFaturamento')}">
          <label class="control-label" for="cidade-faturamento">Cidade</label>

          <input type="text"
                 class="form-control"
                 id="cidade-faturamento"
                 v-model="solicitacao.cidadeFaturamento"
                 data-vv-as="cidade"
                 data-vv-name="cidadeFaturamento"
                 :disabled="desabilitarEndereco"
                 v-validate="'required'"
                 maxlength="60">

          <p class="text-danger" v-show="errors.has('cidadeFaturamento')">{{ errors.first('cidadeFaturamento') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('ufFaturamento')}">
          <label class="control-label" for="uf-faturamento">Estado</label>

          <select id="uf-faturamento"
                  class="form-control"
                  v-model="solicitacao.ufFaturamento"
                  data-vv-as="estado"
                  data-vv-name="ufFaturamento"
                  :disabled="desabilitarEndereco"
                  v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="estado.sigla" v-for="estado in estados">{{ estado.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('ufFaturamento')">{{ errors.first('ufFaturamento') }}</p>
        </div>
      </div>      
    </div>
    
    <div class="row">
      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('telefoneFaturamento')}">
          <label class="control-label" for="telefone-faturamento">Telefone</label>

          <input
              type="text"
              class="form-control"
              id="telefone-faturamento"
              v-mascara="'telefone'"
              v-model="solicitacao.telefoneFaturamento"
              data-vv-as="telefoneResidencial"
              data-vv-name="telefone"
                 maxlength="20"
              v-validate="'required'">

          <p class="text-danger" v-show="errors.has('telefoneFaturamento')">{{ errors.first('telefoneFaturamento') }}</p>
        </div>
      </div>

      <div class="col-lg-3">
        <div class="form-group">
          <label class="control-label" for="fax-faturamento">Fax</label>

          <input
              id="fax-faturamento"
              class="form-control"
              type="text"
              v-mascara="'telefone'"
              maxlength="20"
              v-model="solicitacao.faxFaturamento">
        </div>
      </div>

      <div class="col-lg-6">
        <div class="form-group required" :class="{'has-error': errors.has('contatoFaturamento')}">
          <label class="control-label" for="email-faturamento">Email para envio de NF <small class="text-muted">(Para mais de um email separar utilizando ";")</small></label>

          <input
            type="text"
            class="form-control"
            id="email-faturamento"
            v-model="solicitacao.contatoFaturamento"
            data-vv-as="e-mail"
            data-vv-name="contatoFaturamento"
            v-validate="`required|emailcomposto`"
            maxlength="300"
            v-caracteres-email>

          <p class="text-danger" v-show="errors.has('contatoFaturamento')">{{ errors.first('contatoFaturamento') }}</p>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <label class="control-label" for="contato">Contato para envio de NF/fatura <small class="text-muted">(Para mais de um email separar utilizando ";")</small></label>

          <input type="text"
                 class="form-control"
                 id="contato"
                 v-model="solicitacao.contato"
                 v-validate="`emailcomposto`"
                 data-vv-as="Contato para envio de NF/fatura"
                 data-vv-name="contato"
                 maxlength="100"
                 v-caracteres-email>

          <p class="text-danger" v-show="errors.has('contato')">{{ errors.first('contato') }}</p>
        </div>
      </div>
    </div>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-faturamento/componentes/compartilhado/FormDadosFaturamento.vue